import { api } from '@/api';
import { type FileMetaInfoDto } from '@/api/generator';

export async function downloadFile(file: FileMetaInfoDto) {
  const { result: blob } = await api.filesApi.getFile({ fileId: file.id });

  if (blob) {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = file.name || `Download-${file.id}`;
    link.click();
    URL.revokeObjectURL(link.href);
  }
}

export function downloadUrl(urlString: string) {
  if (URL.canParse(urlString)) {
    const link = document.createElement('a');
    link.href = urlString;
    link.download = '';
    link.click();
    URL.revokeObjectURL(link.href);
  } else {
    throw new Error(`Invalid download URL: ${urlString}`);
  }
}
